<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDati > 0"
      color="blue lighten-4"
      item-key="idx"
      :headers="headers"
      :items="datiMostrati"
      :options.sync="options"
      :server-items-length="totaleDati"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Importazione dati da file Excel</v-toolbar-title>
      </v-toolbar>
      <parametri
        :loading="isImportaDati"
        :loading-categorie="isAggiornaCategorie"
        @changeModello="onChangeModello"
        @importa="importaDati"
        @onLoaded="onLoaded"
        @cambiaVista="cambiaVista"
        @aggiornaCategorie="aggiornaCategorie"
        />
    </template>
    <template v-slot:no-data>
      Imposta il modello e carica un file Excel
    </template>
    </v-data-table>
    <v-dialog
      v-model="isImportaDati"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Importazione dati in corso
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import Parametri from './components/parametri'
  import categorie from '@/services/categorieService'
  import { creaProdotti, creaClienti, aggiornaClienti, creaScontrini, aggiornaGiacenza } from './tipi/dati.js'
  import _ from 'lodash'
  
  export default {
    components: {
      Parametri
    },
    mixins: [verificaLicenza],
    data () {
      return {
        selected: [],
        loading: true,
        options: {},
        expanded: [],
        singleExpand: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null,
        mostaRaw: false,
        datiRaw: [],
        datiModello: [],
        totaleDati: 0,
        intestazioniRaw: [],
        intestazioniModello: [],
        isImportaDati: false,
        modelloItem: null,
        isAggiornaCategorie: false
      }
    },
    async mounted() {
      await this.verificaModuliLocali()
    },
    computed: {
      formTitle () {
        return 'Importazione dati da file Excel' // modificare in base al modello
      },
      datiMostrati() {
        let dati = this.mostaRaw ? this.datiRaw : this.datiModello
        dati = dati.map((x, idx) => { return { idx, ...x } })
        const opz = this.options
        return _.take(_.drop(dati, (opz.page - 1) * opz.itemsPerPage), opz.itemsPerPage)
         
      },
      headers() {
        return this.mostaRaw ? this.creaHeaders(this.intestazioniRaw) : this.creaHeaders(this.intestazioniModello)
      }
    },
    watch: {
      options: {
        async handler () {
          this.loading = false
        },
        deep: true
      }
    },
    methods: {
      backClick() {
        this.$emit('back')
      },
      onChangeModello(modello) {
        this.modelloItem = modello
      },
      onLoaded(dati) {
        if (!dati) {
          this.datiRaw = []
          this.datiModello = []
          this.totaleDati = 0
          this.intestazioniModello = []
          this.intestazioniRaw = []
          return
        }
        this.datiRaw = dati.datiRaw
        this.datiModello = dati.datiModello
        this.totaleDati = dati.datiRaw.length
        this.intestazioniModello = dati.intestazioniModello
        this.intestazioniRaw = dati.intestazioniRaw
      },
      cambiaVista(value) {
        this.mostaRaw = value
      },
      creaHeaders(colonne, dati) {
        const hd = []
        for (let c of colonne) {
          const hh = { text: c.value, value: c.key }
          hd.push(hh)
        }
        return hd
      },
      async importaDati(infoImport) {
        if (this.totaleDati > 0 && this.modelloItem) {
          this.isImportaDati = true
          const dati = this.selected.length > 0 ? this.selected : this.datiModello
          if (this.modelloItem.database === 'prodotti') {
            await creaProdotti(dati, this.modelloItem.datiDefault, this.modelloItem.valoriDefault, infoImport.riferimento, this.modelloItem.taglia_colore)
          }
          if (this.modelloItem.database === 'clienti') {
            if (this.modelloItem.soloAggiornamento) {
              await aggiornaClienti(dati)
            } else {
              await creaClienti(dati, this.modelloItem.datiDefault, this.modelloItem.valoriDefault, infoImport.riferimento)
            }
          }    
          if (this.modelloItem.database === 'scontrini') {
            await creaScontrini(dati, this.modelloItem.datiDefault, this.modelloItem.valoriDefault, infoImport.riferimento)
          }
          if (this.modelloItem.database === 'giacenza') {
            await aggiornaGiacenza(dati, this.modelloItem.magazzino, this.modelloItem.taglia_colore)
          }
          this.isImportaDati = false
          if (infoImport.aggiornaCategorie) {
            await this.aggiornaCategorie()
          }
          this.annullaSelezione()
        }
      },
      async aggiornaCategorie() {
        if (this.modelloItem && this.modelloItem.creaCategorie) {
          this.isAggiornaCategorie = true
          for (const cat of this.modelloItem.creaCategorie) {
            await categorie.generaCategoria(cat.nomeConfigurazione, cat.subCategoria, cat.tipo, cat.nomeCampoSorgente)
          }
          this.isAggiornaCategorie = false
        }
      },
      clickRow(item, options) {
      },
      dblclickRow(event, options) {
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
</style>
